module.exports = __webpack_public_path__ + "img/no broadcast list.0a803868.png";